import ServerDirections from '@/config/server-directions'
import { Guest } from '@/entities/Guest'

import { RequestService } from '@/services/request.service'
const requestService = new RequestService()

var snakeCaseKeys = require('snakecase-keys')

export class GuestRequests {
  get (id) {
    const route = ServerDirections.GUESTS_ID.replace('{id}', id)
    const method = 'get'
    function map (data) {
      return new Guest(data)
    }
    return requestService.makePromise(route, method, {}, map)
  }
  save (guest) {
    const route = ServerDirections.GUESTS
    const method = 'post'
    const body = snakeCaseKeys(guest)
    function map (data) {
      return data.id
    }
    return requestService.makePromise(route, method, { body }, map)
  }
}
